import React, { useState } from "react";
import { Box, Button, TextField, Typography, Alert } from "@mui/material";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebase-config";
import { useNavigate } from "react-router-dom";

export default function CheckinConsoleLogin() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const handleLogin = async () => {
    setError(null);
    setBusy(true);
    try {
      await signInWithEmailAndPassword(auth, email.trim(), password);
      navigate("/checkin-console/events", { replace: true });
    } catch (e) {
      setError(e?.message || "Login failed.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#F8FAFC",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 420,
          bgcolor: "white",
          border: "1px solid rgba(0,0,0,0.08)",
          borderRadius: 2,
          p: 3,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.5 }}>
          Volunteer Check-in
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Sign in to scan QR codes and manage check-in status.
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <TextField
          label="Email"
          fullWidth
          size="small"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{ mb: 1.5 }}
        />

        <TextField
          label="Password"
          fullWidth
          size="small"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          sx={{ mb: 2 }}
        />

        <Button
          variant="contained"
          fullWidth
          disabled={busy || !email || !password}
          onClick={handleLogin}
        >
          {busy ? "Signing in..." : "Sign in"}
        </Button>

        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 2 }}>
          Tip: Use Chrome or Safari on mobile for best camera support.
        </Typography>
      </Box>
    </Box>
  );
}